export default {
  namespaced: true,

  getters: {
    getCodFatEl: (_, __, ___, rootGetters) => id => rootGetters['apis/getObjProp']({ id, key: 'nature', prop: 'CodFatEl' }),
  },
}
